'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _grid = require('@rebass/grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = exports.Message = (0, _components2.default)({
  extend: _grid.Flex,
  px: 3,
  py: 2,
  fontWeight: 'bold',
  color: 'white',
  bg: 'blue',
  alignItems: 'center',
  minHeight: '48px'
}, 'minHeight', 'fontWeight', {
  WebkitFontSmoothing: 'antialiased'
});

Message.displayName = 'Message';

exports.default = Message;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rebass/dist/Message.js
// module id = 120
// module chunks = 4